import React from 'react';
import Head from 'expo-router/head';
import { buildLandingLd, jsonLdScriptProps } from './jsonLd';
import { assetUri } from '../utils/assetUri';
import heroSmallRaw from '../../../assets/images/landing-v2/responsive/hero/small.webp';
import heroSmall2xRaw from '../../../assets/images/landing-v2/responsive/hero/small-2x.webp';
import heroMediumRaw from '../../../assets/images/landing-v2/responsive/hero/medium.webp';

const HERO_SMALL = assetUri(heroSmallRaw);
const HERO_SMALL_2X = assetUri(heroSmall2xRaw);
const HERO_MEDIUM = assetUri(heroMediumRaw);

export function LandingHead({ content, canonical }) {
  const ld = buildLandingLd({
    seoTitle: content.seo.title,
    seoDescription: content.seo.description,
    canonical,
    faqItems: content.faq.questions || [],
  });

  return (
    <Head>
      <title>{content.seo.title}</title>
      <meta name="description" content={content.seo.description} />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <meta property="og:title" content={content.seo.title} />
      <meta property="og:description" content={content.seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      {content.seo.ogImage ? <meta property="og:image" content={content.seo.ogImage} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en-gb" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      <link
        rel="preload"
        as="image"
        href={HERO_MEDIUM}
        imageSrcSet={`${HERO_SMALL} 640w, ${HERO_SMALL_2X} 1280w, ${HERO_MEDIUM} 1024w`}
        imageSizes="100vw"
        fetchPriority="high"
      />
      {ld.map((payload, idx) => (
        <script key={idx} {...jsonLdScriptProps(payload)} />
      ))}
    </Head>
  );
}
